import { action, makeObservable, observable, toJS } from "mobx";

import { LinkedInChildApplicationResponse } from "../models/linkedin-manager/LinkedInChildApplicationResponse";

export class LinkedInStore {
  
  @observable
  linkedInChildApplication? : LinkedInChildApplicationResponse;
  
  @observable
  public IsDataLoading: boolean = false;

  /**
   * Ctor
   */
  constructor() {
    makeObservable(this);
  }

  @action
  public async SetIsDataLoading(state: boolean) {
    this.IsDataLoading = state;
  }

  
  @action
  public async SetLinkedInChildApplication(linkedInChildApplication: LinkedInChildApplicationResponse) {
    this.linkedInChildApplication = linkedInChildApplication;
  }
}
